/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AffiliatedGroupDetail } from '../../models/affiliated-group-detail';
import { AffiliatedGroupSave } from '../../models/affiliated-group-save';

export interface CreateAffiliatedGroup$Params {
      body: AffiliatedGroupSave
}

export function createAffiliatedGroup(http: HttpClient, rootUrl: string, params: CreateAffiliatedGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<AffiliatedGroupDetail>> {
  const rb = new RequestBuilder(rootUrl, createAffiliatedGroup.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AffiliatedGroupDetail>;
    })
  );
}

createAffiliatedGroup.PATH = '/rest/admin/affiliated-group';
